import React from 'react';

const TermsModal = ({ 
    isVisible, 
    onClose, 
    onAccept, 
    termsData, 
    loading = false 
}) => {
    if (!isVisible) return null;
  
    return (
        <div className="modal" style={{ 
            display: 'block', 
            position: 'fixed', 
            top: 0, 
            left: 0, 
            width: '100%', 
            height: '100%', 
            backgroundColor: 'rgba(0,0,0,0.5)', 
            zIndex: 9999 
        }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Terms and Conditions</h5>
                        <button 
                            type="button" 
                            className="btn-close" 
                            onClick={onClose}
                            aria-label="Close"
                            style={{
                                background: 'none',
                                border: 'none',
                                fontSize: '1.5rem',
                                cursor: 'pointer'
                            }}
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    
                    <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                        {loading ? (
                            <div className="text-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2">Loading terms and conditions...</p>
                            </div>
                        ) : (
                            <>
                                {console.log('TermsModal - termsData:', termsData)}
                                {termsData && termsData.length > 0 ? (
                                    termsData.map((document, index) => (
                                        <div key={document._id || document.id || index} className="mb-4">        
                                            {/* Document Content */}
                                            {document.type === 'rich_text' && document.content ? (
                                                <div 
                                                    dangerouslySetInnerHTML={{ __html: document.content }}
                                                    style={{ 
                                                        padding: '15px', 
                                                      
                                                        backgroundColor: '#f8f9fa',
                                                       
                                                    }}
                                                />
                                            ) : document.type === 'file' && document.uploadedFile ? (
                                                <div className="file-document">
                                                    <p><strong>File:</strong> {document.uploadedFile.filename}</p>
                                                    <a 
                                                        href={document.uploadedFile.url} 
                                                        target="_blank" 
                                                        rel="noopener noreferrer"
                                                        className="btn btn-outline-primary btn-sm"
                                                    >
                                                        View Document
                                                    </a>
                                                </div>
                                            ) : (
                                                <div className="alert alert-warning">
                                                    <p className="mb-0">No content available for this document.</p>
                                                </div>
                                            )}
                                            
                                            
                                            
                                            {/* Separator between multiple documents */}
                                            {index < termsData.length - 1 && <hr className="my-4" />}
                                        </div>
                                    ))
                                ) : (
                                    <div className="alert alert-info">
                                        <h6>No legal documents found</h6>
                                        <p className="mb-0">
                                            We couldn't find any terms and conditions documents at this time. 
                                            Please contact support if this issue persists.
                                        </p>
                                        {/* Debug info in development */}
                                        {process.env.NODE_ENV === 'development' && (
                                            <details className="mt-2">
                                                <summary>Debug Info</summary>
                                                <pre>{JSON.stringify(termsData, null, 2)}</pre>
                                            </details>
                                        )}
                                    </div>
                                )}
                            </>
                        )}
                    </div>
                    
                    <div className="modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-secondary" 
                            onClick={onClose}
                            disabled={loading}
                        >
                            {loading ? 'Loading...' : 'Close'}
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={onAccept}
                            disabled={loading || !termsData || termsData.length === 0}
                        >
                            Accept Terms
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsModal;